import React, { useCallback, useState } from "react";
import { Modal, Button, Text, Input, Loading } from "@nextui-org/react";
import { useNotifications } from "reapop";
import useStorage from "../storage/useLocalStorage";
import { makeFetch } from "../../service/makeFetch";

export default function Confirm({
  children,
  makeVisible = false,
  setVisible = () => null,
  info = { role: "Developer" },
  action = () => null,
}) {
  const { notify } = useNotifications();
  const [isDeletingUser, setIsDeletingUser] = useState(false);
  const [textConfirmation, setTextConfirmation] = useState("");
  const [refreshAccount = false, setRefreshAccount] =
    useStorage("refreshAccount");

  const closeHandler = () => {
    setVisible(false);
    setTextConfirmation("");
  };
  const onTextChange = useCallback((e) => {
    setTextConfirmation(e.target.value);
  }, []);

  const updateAccount = useCallback(async () => {
    if (isDeletingUser === true) return;
    if (textConfirmation !== "delete")
      return notify(`Please write "delete" to confirm!`, "error");
    setIsDeletingUser(true);
    const obj = {
      isDeleted: true,
    };
    const result = await makeFetch({
      url: `account/update`,
      method: "POST",
      privateCall: false,
      body: {
        userId: info.id,
        itemDetailsUpdate: obj,
      },
    });
    setIsDeletingUser(false);
    if (result === undefined || result === null) {
      notify("Error getting data failed!", "error");
      return;
    }
    if (result?.error === true) {
      notify(result.message, "error");
      return;
    } else {
      notify("User deleted!", "success");
      setRefreshAccount(true);
      closeHandler();
    }
    if (typeof window !== "undefined") {
      // setData(result);
    }
  }, [info, isDeletingUser, textConfirmation]);

  return (
    <div>
      {children}
      <Modal
        closeButton
        blur
        aria-labelledby="modal-title"
        open={makeVisible}
        onClose={closeHandler}
        width="400px"
      >
        <Modal.Header>
          <Text id="modal-title" size={18} b>
            You are about to delete {info?.name} type delete to confirm!
          </Text>
        </Modal.Header>
        <Modal.Body>
          <Input
            value={textConfirmation}
            label="Confirm"
            placeholder={"delete"}
            onChange={onTextChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button auto flat color="error" onPress={closeHandler}>
            Close
          </Button>
          <Button auto onPress={updateAccount}>
            {isDeletingUser === true ? (
              <Loading size="sm" color={"white"} />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
